module.exports = __webpack_public_path__ + "static/media/chat-mob.409b6c5b.svg";